﻿import { echartSetOption } from './echarts-utils';

const drivingModeVehicleInit = () => {
  const { getColor, getData } = window.phoenix.utils;
  const chartEl = document.querySelector('.echart-vehicle-mode');

  if (chartEl) {
    const userOptions = getData(chartEl, 'echarts');
    const chart = window.echarts.init(chartEl);

    const getImage = type => {
      let images = {};
      if (window.config.config.phoenixTheme === 'dark') {
        images = {
          Drive: '/img/activity-icons/drive_dark.svg',
          Rest: '/img/activity-icons/rest_dark.svg',
          Available: '/img/activity-icons/available_dark.svg',
          Work: '/img/activity-icons/work_dark.svg',
          Unknown: '/img/activity-icons/unknown_dark.svg'
        };
      } else {
        images = {
          Drive: '/img/activity-icons/drive.svg',
          Rest: '/img/activity-icons/rest.svg',
          Available: '/img/activity-icons/available.svg',
          Work: '/img/activity-icons/work.svg',
          Unknown: '/img/activity-icons/unknown.svg'
        };
      }
      return images[type];
    };

    const getDefaultOptions = () => ({
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        padding: [7, 10],
        backgroundColor: getColor('body-highlight-bg'),
        borderColor: getColor('border-color'),
        textStyle: { color: getColor('light-text-emphasis') },
        borderWidth: 1,
        transitionDuration: 0
      },
      xAxis: {
        type: 'value',
        show: false
      },
      yAxis: [
        {
          type: 'category',
          inverse: true,
          axisLine: { show: false },
          axisLabel: {
            formatter: value => {
              return `{${value}|}`;
            },
            rich: {
              drive: {
                height: 28,
                width: 28,
                backgroundColor: { image: getImage('Drive') }
              },
              rest: {
                height: 28,
                width: 28,
                backgroundColor: { image: getImage('Rest') }
              },
              available: {
                height: 28,
                width: 28,
                backgroundColor: { image: getImage('Available') }
              },
              work: {
                height: 28,
                width: 28,
                backgroundColor: { image: getImage('Work') }
              },
              unknown: {
                height: 28,
                width: 28,
                backgroundColor: { image: getImage('Unknown') }
              }
            }
          },
          splitLine: {
            show: true,
            lineStyle: { color: getColor('secondary-bg') }
          },
          axisTick: { show: false }
        },
        {
          type: 'category',
          inverse: true,
          axisLine: { show: false },
          axisTick: { show: false }
        }
      ],
      series: [
        {
          name: '',
          type: 'bar',
          lineStyle: { color: getColor('primary') },
          itemStyle: {
            color: getColor('primary'),
            barBorderRadius: [0, 3, 3, 0]
          },
          showSymbol: false,
          symbol: 'circle',
          smooth: false,
          hoverAnimation: true
        }
      ],
      grid: { right: '40', left: '40', top: '0%', bottom: '10%' }
    });
    echartSetOption(chart, userOptions, getDefaultOptions);

    if (window.chartReadyCallback) {
      window.chartReadyCallback(chart);
    }
  }
};

export default drivingModeVehicleInit;
